import { DEV } from "solid-js"
import { useHoveredPositionSignal } from "../../../../rx/signal/useHoveredPositionSignal"
import { useSelectedPositionListSignal } from "../../../../rx/signal/useSelectedPositionListSignal"
import useSelectionModeSignal from "../../../../rx/signal/useSelectionModeSignal"
import type { Engine } from "../../../core/engine/Engine.type"
import { SelectionMode } from "../../../core/engine/SelectionMode/SelectionMode.enum"
import findByPosition from "../../../core/findByPosition"
import { samePosition } from "../../../core/tile_position_xy/samePosition"
import type { TilePositionXY } from "../../../core/tile_position_xy/TilePositionXY.type"
import { immutableEmptyArray } from "../../../lib"
import { EventResult } from "../../event"
import type { ActionBindingEvent } from "../ActionBindingEvent.type"

export default function createDefaultPointerSelectionInputActionHandler (engine : Engine) {
  const [getSelectionMode] = useSelectionModeSignal(engine)
  const [getSelectedPositionList, setSelectedPositionList] = useSelectedPositionListSignal(engine)
  const [getHoveredPosition] = useHoveredPositionSignal(engine)
  // const isInputShiftModifier = useSharedIsInputShiftModifierMemo(engine)

  function handlePrimary(event: ActionBindingEvent): EventResult.Stop {
    const mode = getSelectionMode()
    const selectedPositionList0 = getSelectedPositionList()
    const hoveredPosition = getHoveredPosition()

    // TODO: acquire position directly from event, fallback to hoveredPosition
    const targetPosition = hoveredPosition

    if (targetPosition) {  
      if (event.shiftKey || mode === SelectionMode.MultiSelect) {
        // console.log('Primary+shift', event)
        const alreadyInList = findByPosition(selectedPositionList0, targetPosition)
        if (alreadyInList) {
          // remove if target is already there
          // console.log('Primary.remove', targetPosition)
          setSelectedPositionList(selectedPositionList0.filter(tp => !samePosition(tp, targetPosition)))
        } else {
          // add if target is not there
          // console.log('Primary.add', targetPosition)
          setSelectedPositionList([
            ...selectedPositionList0,
            targetPosition,
          ])
        }
      } else if (mode === SelectionMode.SingleSelect) {
        // console.log('Primary', event)
        const alreadyInList = findByPosition(selectedPositionList0, targetPosition)
        if (alreadyInList) {
          // remove if target is already there
          // console.log('Primary.remove', targetPosition)
          setSelectedPositionList(immutableEmptyArray as unknown as TilePositionXY[])
        } else {
          // add if target is not there
          // console.log('Primary.add', targetPosition)
          setSelectedPositionList([targetPosition])
        }
      } else if (DEV) {
        throw new Error('Invalid selection mode')
      }
    }
    // console.log('Primary.data', deepClone({
    //   targetPosition: targetPosition,
    //   selectedPositionList0,
    //   selectedPositionList1: getSelectedPositionList(),
    // }))
    // setTimeout(() => {
    //   console.log('Primary.data2', deepClone({
    //     targetPosition: targetPosition,
    //     selectedPositionList0,
    //     selectedPositionList1: getSelectedPositionList(),
    //   }))
    // }, 10)
    return EventResult.Stop
  }
  
  return handlePrimary
}